import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Controller } from 'react-hook-form'
import type { Control } from 'react-hook-form'
import { InlineAlert, TextField } from '@chillout/ui'
import { SelectField } from '../../../../shared/SelectField'
import { DeviceNameConflictError } from '../deviceErrors'

interface AddDeviceFormProps {
  control: Control<{ name: string; branchId: string }>
  branchOptions: { label: string; value: string }[]
  isError: boolean
  error: Error | null
}

export function AddDeviceForm({ control, branchOptions, isError, error }: AddDeviceFormProps) {
  const { t } = useTranslation()
  return (
    <View className="mt-6 gap-5">
      <Controller
        control={control}
        name="name"
        render={({ field, fieldState }) => (
          <TextField
            label={t('operations.addDevice.deviceNameLabel')}
            placeholder={t('operations.addDevice.deviceNamePlaceholder')}
            value={field.value}
            onChangeText={field.onChange}
            onBlur={field.onBlur}
            error={fieldState.error?.message}
          />
        )}
      />
      <Controller
        control={control}
        name="branchId"
        render={({ field, fieldState }) => (
          <SelectField
            label={t('operations.addDevice.branchLabel')}
            placeholder={t('operations.addDevice.branchPlaceholder')}
            value={field.value}
            options={branchOptions}
            onValueChange={field.onChange}
            error={fieldState.error?.message}
          />
        )}
      />
      {isError && (
        <InlineAlert message={
          error instanceof DeviceNameConflictError
            ? t('operations.addDevice.nameConflictError')
            : t('operations.addDevice.submitError')
        } />
      )}
    </View>
  )
}
